export function simpleHash(str : string) {
    let hash = 5381; // Initial value

    for (let i = 0; i < str.length; i++) {
        hash = (hash * 33) ^ str.charCodeAt(i);
    }

    // Convert to a 32-character hexadecimal string
    return ("00000000" + (hash >>> 0).toString(16)).substr(-32);
}